if (!customElements.get('clipboard-text')) {
  class ClipboardText extends HTMLElement {
    constructor() {
      super();
      this.text = this.querySelector('.clipboard-text').innerText;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.copyText.bind(this));
    }

    copyText(e) {
      navigator.clipboard.writeText(this.text).then(() => {
        this.showMessage();
      });
    }

    showMessage() {
      const el = document.createElement('div');
      el.className = 'clipboard-copy-success-message';
      el.innerText = this.dataset.alertMessage || 'Copied to clipboard';
      
      document.body.appendChild(el);

      // trigger animation
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });

      // remove after 2s
      setTimeout(() => {
        el.style.opacity = '0';
        el.addEventListener('transitionend', () => el.remove(), { once: true });
      }, 2000);
    }
  }
  customElements.define('clipboard-text', ClipboardText);
}